export default __webpack_public_path__ + "static/media/Cheng-Ho Battle Dagger.54f5085b.jpg";